var React = require('react');

function SmallOval (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"oval","opacity":"0.4","x":"120","width":"159.6","height":"120","rx":"60","transform":"rotate(90 120 0)","fill":"url(#paint0_linear_1673_26353)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_1673_26353","x1":"151.826","y1":"110.758","x2":"264.356","y2":"-8.64315","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#C4F1F9","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#0BC5EA","key":1})]))]);
}

SmallOval.defaultProps = {"width":"120","height":"160","viewBox":"0 0 120 160","fill":"none"};

module.exports = SmallOval;

SmallOval.default = SmallOval;
